import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const RegistrationSuccess = ({ 
  email, 
  onResendVerification, 
  onContinue,
  isResending = false 
}) => {
  const nextSteps = [
    {
      icon: 'Mail',
      title: 'Controleer uw e-mail',
      description: `We hebben een verificatielink gestuurd naar ${email}`
    },
    {
      icon: 'MousePointer',
      title: 'Klik op de link',
      description: 'Klik op de verificatielink in de e-mail om uw account te activeren'
    },
    {
      icon: 'LogIn',
      title: 'Begin met zoeken',
      description: 'Log in en begin met het vinden van de perfecte duurzaamheidsprovider'
    }
  ];

  return (
    <div className="text-center space-y-8">
      {/* Success Icon */}
      <div className="flex justify-center">
        <div className="w-20 h-20 bg-success/10 rounded-full flex items-center justify-center">
          <Icon name="CheckCircle" size={40} color="var(--color-success)" />
        </div>
      </div>
      {/* Success Message */}
      <div className="space-y-2">
        <h2 className="text-2xl font-heading font-semibold text-foreground">
          Account succesvol aangemaakt!
        </h2>
        <p className="text-muted-foreground font-body">
          Welkom bij Verduurzaamwijzer. Nog één stap en u kunt beginnen.
        </p>
      </div>
      {/* Next Steps */}
      <div className="bg-card border border-border rounded-lg p-6 text-left">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4 text-center">
          Volgende stappen
        </h3>
        
        <div className="space-y-4">
          {nextSteps?.map((step, index) => (
            <div key={index} className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
                  <span className="text-sm font-caption font-semibold text-primary">
                    {index + 1}
                  </span>
                </div>
              </div>
              <div className="flex-1">
                <div className="flex items-center space-x-2 mb-1">
                  <Icon name={step?.icon} size={16} color="var(--color-primary)" />
                  <h4 className="font-heading font-medium text-foreground">
                    {step?.title}
                  </h4>
                </div>
                <p className="text-sm font-body text-muted-foreground">
                  {step?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Email Issues */}
      <div className="bg-muted/30 rounded-lg p-4">
        <h4 className="font-heading font-medium text-foreground mb-2">
          Geen e-mail ontvangen?
        </h4>
        <p className="text-sm font-body text-muted-foreground mb-4">
          Controleer uw spam/junk folder of vraag een nieuwe verificatie-e-mail aan.
        </p>
        
        <Button
          variant="outline"
          size="sm"
          onClick={onResendVerification}
          loading={isResending}
          iconName="RefreshCw"
          iconPosition="left"
        >
          Nieuwe e-mail versturen
        </Button>
      </div>
      {/* Continue Button */}
      <div className="space-y-3">
        <Button
          variant="default"
          size="lg"
          fullWidth
          onClick={onContinue}
          iconName="ArrowRight"
          iconPosition="right"
        >
          Ga naar inlogpagina
        </Button>
        
        <p className="text-xs font-body text-muted-foreground">
          U kunt ook later terugkomen om uw account te verifiëren
        </p>
      </div>
    </div>
  );
};

export default RegistrationSuccess;